import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TResetPasswordPageProps = {};

export const ResetPasswordPage: FC<TResetPasswordPageProps> = () => {
  return (
    <Stack gap={4} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワード再発行</Typography>
      <Typography variant="body14" width={"100%"}>
        新しいパスワードを入力してください。
      </Typography>
      <ResetPasswordForm />
    </Stack>
  );
};
